<template>
  <el-container>
    <el-header>
      <navbar></navbar>
    </el-header>
    <el-container>
      <el-aside width="202px">
        <sidebar></sidebar>
      </el-aside>
      <el-main>
        <router-view />
        <div class="footer">Powered by iCTR_TB!</div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import "@/assets/css/style.css";

export default {
  components: {
    Navbar,
    Sidebar,
  },
};
</script>
<style>
.footer {
  width: 100%;
  color: #c5c5c5;
  height: 45px;
  line-height: 45px;
  font-size: 14px;
  text-align: center;
  text-shadow: 0 1px 1px rgba(205, 205, 205, 0.6);
}
</style>
